import styled, { css } from 'styled-components';
import { CarvanaTheme, getMediaQuery } from '@carvana/showroom-theme';
import { AlertCircle } from '@carvana/icons';
import { ModalContent } from '@carvana/modal';

export const navSectionStyles = css`
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  display: flex;
  padding: 0 30px;
`;

export const Wrapper = styled.div`
  background-color: white;
  width: 100%;

  ${getMediaQuery(CarvanaTheme.breakpoint.md)} {
    max-width: 320px;
    padding-bottom: 84px;
  }

  ${getMediaQuery(CarvanaTheme.breakpoint.xl)} {
    max-width: 336px;
  }

  ${getMediaQuery(CarvanaTheme.breakpoint.xxl)} {
    max-width: 384px;
  }
`;

export const Section = styled.section``;

export const SectionHeader = styled.div`
  ${navSectionStyles}
  font-size: 14px;
  height: 56px;

  > span:first-of-type {
    color: ${props => props.theme.carvana.blue.dark};
    font-weight: bold;
    text-transform: uppercase;
  }

  ${Section}.disabled & {
    color: ${props => props.theme.carvana.gray.medium};
  }
`;

export const SectionStatusWrapper = styled.div`
  align-items: center;
  color: ${props => props.theme.carvana.blue.primary};
  display: flex;
  margin-left: auto;

  ${Section}.disabled & {
    color: ${props => props.theme.carvana.gray.medium};
  }
`;

export const SectionStatusText = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
`;

export const SectionStatusActionRequiredText = styled.p`
  font-size: 12px;
  font-weight: normal;
  color: ${props => props.theme.carvana.red.primary};
`;

export const RequiresAttentionIconRed = styled(AlertCircle)`
  align-items: center;

  border-radius: 50%;
  display: flex;
  height: 14px;
  justify-content: center;
  margin-left: 4px;
  width: 12px;

  & > svg > g {
    fill: ${props => props.theme.carvana.red.primary};
  }
`;

export const NavTabsWrapper = styled.div``;

export const CancelAction = styled.div`
  ${navSectionStyles}

  border-bottom: none;
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 14px;
  cursor: pointer;
  height: 56px;
`;

export const EditAction = styled.div`
  ${navSectionStyles}

  border-bottom: none;
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 14px;
  cursor: pointer;
  height: 56px;
`;

export const Content = styled(ModalContent)`
  z-index: 1301;

  &.loading {
    overflow-y: visible;
  }
`;

export const CancelOrderText = styled.span`
  color: ${props => props.theme.carvana.blue.primary};
`;

export const EditOrderText = styled.span`
  color: ${props => props.theme.carvana.blue.primary};
`;
